"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewPackages = void 0;
/* Package Imports */
var classnames_1 = __importDefault(require("classnames"));
var lodash_1 = __importDefault(require("lodash"));
var moment_1 = __importDefault(require("moment"));
var react_1 = __importStar(require("react"));
var react_device_detect_1 = require("react-device-detect");
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var react_toastify_1 = require("react-toastify");
/* Imported CSS */
require("./NewPackages.scss");
require("@app/styles/PackageLists.scss");
/* Blast Imports */
var actions_1 = require("../state/actions");
var models_1 = require("@app/_state/models");
var LoadingIndicator_1 = require("@app/components/LoadingIndicator");
var Button_1 = require("@app/components/controls/Button");
var InfoIcon_1 = require("@app/components/controls/InfoIcon");
var DownloadButton_1 = require("@app/components/packages/DownloadButton");
var OpenDownloadButton_1 = require("@app/components/packages/OpenDownloadButton");
var PackageExpiration_1 = require("@app/components/packages/PackageExpiration");
var PackageFileSize_1 = require("@app/components/packages/PackageFileSize");
var PackageProgressBar_1 = require("@app/components/packages/PackageProgressBar");
var PackageProgressDetails_1 = require("@app/components/packages/PackageProgressDetails");
var PauseButton_1 = require("@app/components/packages/PauseButton");
var RefreshButton_1 = require("@app/components/packages/RefreshButton");
var RetryButton_1 = require("@app/components/packages/RetryButton");
var actions_2 = require("@app/features/package-details/state/actions");
var SortHeader_1 = require("@app/features/package-history/components/SortHeader");
var actions_3 = require("@app/features/transfers/state/actions");
var models_2 = require("@app/features/transfers/state/models");
var selectors_1 = require("@app/features/transfers/state/selectors");
var constants_1 = require("@app/shared/constants");
var log_1 = __importDefault(require("@app/shared/log"));
var matomo_1 = require("@app/shared/matomo");
var utils_1 = require("@app/shared/utils");
var constants_2 = require("@server/shared/constants");
var api_1 = require("@server/types/api");
var initialState = {
    offset: 0
};
var HistoryLink = function () { return (react_1.default.createElement(react_router_dom_1.Link, { to: "/dash/packages/history/received", className: "has-text-info has-text-weight-bold" },
    react_1.default.createElement("i", { className: "far fa-clock" }),
    " History")); };
/**
 * Blast's New Packages component, displays all the packages in a user's inbox
 * The status of "new" meaning the package has not expired and the user has yet to take any action against the package
 */
var NewPackages = /** @class */ (function (_super) {
    __extends(NewPackages, _super);
    function NewPackages() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = initialState;
        /* Component Lifecycle Methods - End */
        /* Component Methods - Begin */
        _this.handleCancelDismiss = function (packageId) {
            _this.props.onCancelDismiss(packageId);
        };
        _this.handleCheckTransferStatus = function (packageId) {
            _this.props.onCheckTransferStatus(packageId);
        };
        _this.handleConfirmDismiss = function (packageId) {
            _this.props.onConfirmDismiss(packageId);
            new matomo_1.MatomoTracker().trackEvent('New Packages', 'Dismiss Package', packageId);
        };
        _this.handleDismiss = function (title, creationDate) {
            _this.props.onDismiss(title, creationDate);
        };
        _this.handleDownload = function (pkg) {
            if (_this.props.asperaEnabled) {
                _this.props.onConnectDownload(pkg.id);
            }
            else {
                if (_this.props.httpGatewayStatus) {
                    log_1.default.debug("DOWNLOADING USING GATEWAY");
                    var activeGatewayDownloads = _this.props.activeTransfersList.filter(function (t) { return t.type === models_2.TransferType.GATEWAY && t.direction === api_1.Direction.RECEIVE; });
                    if (activeGatewayDownloads.length < constants_1.ACTIVE_GATEWAY_DOWNLOAD_LIMIT) {
                        _this.props.onHttpGatewayDownload(pkg);
                    }
                    else {
                        react_toastify_1.toast.warning(lodash_1.default.capitalize(utils_1.numToWords(constants_1.ACTIVE_GATEWAY_DOWNLOAD_LIMIT)) + " downloads are already in progress.\nPlease enable Aspera to download more than " + utils_1.numToWords(constants_1.ACTIVE_GATEWAY_DOWNLOAD_LIMIT) + " packages at a time.", {
                            autoClose: 10000,
                            toastId: constants_1.GATEWAY_DOWNLOAD_LIMIT_WARNING
                        });
                    }
                }
                else {
                    log_1.default.debug("DOWNLOADING USING PLUGINLESS");
                    _this.props.onHttpDownload(pkg);
                }
            }
            new matomo_1.MatomoTracker().trackEvent('New Packages', 'Download Package', pkg.id);
        };
        _this.handleDownloadRetry = function (pkg) {
            if (_this.props.asperaEnabled) {
                if (pkg.packageTransferId) {
                    _this.props.onResumeConnectTransfer(pkg.packageTransferId);
                }
                else {
                    _this.props.onConnectDownload(pkg.id);
                }
            }
            else {
                if (_this.props.httpGatewayStatus) {
                    log_1.default.debug("RETRYING DOWNLOAD USING GATEWAY");
                    var activeGatewayDownloads = _this.props.activeTransfersList.filter(function (t) { return t.type === models_2.TransferType.GATEWAY && t.direction === api_1.Direction.RECEIVE; });
                    if (activeGatewayDownloads.length < constants_1.ACTIVE_GATEWAY_DOWNLOAD_LIMIT) {
                        _this.props.onHttpGatewayDownload(pkg);
                    }
                    else {
                        react_toastify_1.toast.warning(lodash_1.default.capitalize(utils_1.numToWords(constants_1.ACTIVE_GATEWAY_DOWNLOAD_LIMIT)) + " downloads are already in progress.\nPlease enable Aspera to download more than " + utils_1.numToWords(constants_1.ACTIVE_GATEWAY_DOWNLOAD_LIMIT) + " packages at a time.", {
                            autoClose: 10000,
                            toastId: constants_1.GATEWAY_DOWNLOAD_LIMIT_WARNING
                        });
                    }
                }
                else {
                    log_1.default.debug("RETRYING DOWNLOAD USING PLUGINLESS");
                    _this.props.onHttpDownload(pkg);
                }
            }
            var retryEventLog = (_this.props.asperaEnabled) ? 'Resume Download Package' : 'Retry Download Package';
            new matomo_1.MatomoTracker().trackEvent('New Packages', retryEventLog, pkg.id);
        };
        _this.handleDownloadStop = function (pkg) {
            if (pkg.packageTransferId) {
                _this.props.onStopConnectTransfer(pkg.packageTransferId);
                new matomo_1.MatomoTracker().trackEvent('New Packages', 'Stop Download Package', pkg.id);
            }
            else {
                log_1.default.debug("Unable to stop transfer of '" + pkg.title + "' (" + pkg.id + ")");
            }
        };
        _this.handleLoadMore = function () {
            if (_this.props.workgroupEmail !== '') {
                // Load more packages in relation to the Workgroup
                _this.setState({ offset: _this.state.offset + _this.props.pageSize }, function () {
                    _this.props.onGetWorkgroupPackages(_this.state.offset, _this.props.pageSize, _this.props.workgroupEmail ? _this.props.workgroupEmail : '', _this.props.searchTerm, true);
                });
            }
            else {
                // Load more packages in relation to the Inbox
                _this.setState({ offset: _this.state.offset + _this.props.pageSize }, function () {
                    _this.props.onGetPackages(_this.state.offset, _this.props.pageSize, _this.props.searchTerm, true, false);
                });
            }
            new matomo_1.MatomoTracker().trackEvent('New Packages', 'Load More');
        };
        _this.handleOnPush = function (id) {
            _this.props.saveSearchTerm(_this.props.searchTerm ? _this.props.searchTerm : '');
            _this.props.onPush(id);
        };
        _this.handleOpenDownload = function (pkg) {
            if (_this.props.asperaEnabled && pkg.packageTransferId) {
                _this.props.onOpenDownload(pkg.packageTransferId);
                new matomo_1.MatomoTracker().trackEvent('New Packages', 'Open Downloaded Package', pkg.id);
            }
            else {
                react_toastify_1.toast.error('Couldn\'t open the downloaded package');
            }
        };
        _this.handleOpenPreferences = function () {
            _this.props.onOpenPreferences();
        };
        _this.handleOpenTransferManager = function () {
            _this.props.onOpenTransferManager();
        };
        _this.handleSort = function (sortKey) {
            _this.props.onSort(sortKey, _this.props.pageSize, _this.props.searchTerm);
        };
        return _this;
    }
    /* Component Lifecycle Methods - Begin */
    NewPackages.prototype.componentDidMount = function () {
        if (this.props.packageCacheLastRefresh) {
            if (this.props.workgroupEmail === '') {
                this.props.onResetNewPackages(this.props.pageSize, this.props.searchTerm);
            }
            else {
                this.props.onGetWorkgroupPackages(0, this.props.pageSize, this.props.workgroupEmail ? this.props.workgroupEmail : '', this.props.searchTerm, false);
            }
        }
    };
    NewPackages.prototype.componentDidUpdate = function (prevProps) {
        var _this = this;
        // When user first signs into Blast for the first time sometimes the package cache has not been built yet
        // In that case, wait for the cache to refresh, then get the user's new packages
        if (prevProps.packageCacheLastRefresh !== this.props.packageCacheLastRefresh &&
            (this.props.packages.length === 0 && this.props.searchTerm === '' && this.props.numPackageRefreshes < 1)) {
            this.props.onResetNewPackages(this.props.pageSize);
        }
        else {
            if (this.props.workgroupEmail !== '') { // Looking for Workgroup specific packages
                if (prevProps.workgroupEmail !== this.props.workgroupEmail) {
                    // if the Workgroup has changed, search for packages in the new Workgroup
                    this.setState({ offset: 0 }, function () {
                        _this.props.onGetWorkgroupPackages(0, _this.props.pageSize, _this.props.workgroupEmail ? _this.props.workgroupEmail : '', _this.props.searchTerm, false);
                    });
                }
                else {
                    if (prevProps.searchTerm !== this.props.searchTerm) {
                        // if searchTerm has changed, search for packages in Workgroup w/ the new searchTerm
                        this.setState({ offset: 0 }, function () {
                            _this.props.onGetWorkgroupPackages(0, _this.props.pageSize, _this.props.workgroupEmail ? _this.props.workgroupEmail : '', _this.props.searchTerm, false);
                        });
                    }
                }
            }
            else { // Looking for Inbox packages
                if (prevProps.workgroupEmail !== this.props.workgroupEmail) {
                    // Previously looking at a Workgroup, reset the Inbox packages
                    this.props.onResetNewPackages(this.props.pageSize);
                }
                else {
                    if (prevProps.searchTerm !== this.props.searchTerm) {
                        // if searchTerm has changed, search the Inbox packages w/ the new searchTerm
                        this.setState({ offset: 0 }, function () {
                            _this.props.onGetPackages(0, _this.props.pageSize, _this.props.searchTerm, false, false);
                        });
                    }
                }
            }
        }
    };
    /* Component Methods - End */
    NewPackages.prototype.render = function () {
        var _this = this;
        var _a = this.props, containsArchivedPackages = _a.containsArchivedPackages, isSearching = _a.isSearching, packages = _a.packages, searchTerm = _a.searchTerm, sortDirection = _a.sortDirection, sortKey = _a.sortKey, totalCount = _a.totalCount, totalSearchCount = _a.totalSearchCount, workgroupEmail = _a.workgroupEmail;
        var loadingPackageTitle = react_1.default.createElement("h1", null, "Searching Packages");
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "box new-packages" },
                (((packages.length === 0) && (totalCount === 0)) || ((packages.length === 0) && (workgroupEmail !== ''))) &&
                    react_1.default.createElement("div", { className: "content" },
                        react_1.default.createElement("p", null,
                            "Nothing to see here! Looks like ",
                            (!workgroupEmail || workgroupEmail === '') ? "you don't have any new packages..." :
                                workgroupEmail + " doesn't have any packages..."),
                        react_1.default.createElement("p", null,
                            "To view recently sent or received packages, go to ",
                            react_1.default.createElement(react_router_dom_1.Link, { to: "/dash/packages/history" },
                                react_1.default.createElement("i", { className: "fas fa-clock fa-fw" }),
                                react_1.default.createElement("span", null, "History")),
                            "."),
                        react_1.default.createElement("p", null,
                            "To send a new package, go to ",
                            react_1.default.createElement(react_router_dom_1.Link, { to: "/dash/packages/upload" },
                                react_1.default.createElement("i", { className: "fas fa-rocket fa-fw" }),
                                react_1.default.createElement("span", null, "Send")),
                            ".")),
                ((packages.length > 0) || (packages.length === 0 && searchTerm !== '')) && ((totalCount > 0) || ((workgroupEmail !== '') && (totalSearchCount > 0)) || (containsArchivedPackages)) &&
                    react_1.default.createElement("div", { className: "table new-packages-table is-fullwidth" },
                        react_1.default.createElement("div", { className: "columns header is-mobile" },
                            react_1.default.createElement("div", { className: "column is-1 th is-variable" }),
                            react_1.default.createElement(SortHeader_1.SortHeader, { className: 'is-2 is-resize has-archive', sortKey: constants_2.senderNameSortField, text: "Sender", currentSortKey: sortKey, currentSortDirection: sortDirection, onClick: this.handleSort }),
                            react_1.default.createElement(SortHeader_1.SortHeader, { className: 'is-3 is-resize has-archive', sortKey: constants_2.titleSortField, text: "Subject", currentSortKey: sortKey, currentSortDirection: sortDirection, onClick: this.handleSort }),
                            react_1.default.createElement(SortHeader_1.SortHeader, { className: 'is-1 is-variable', sortKey: constants_2.sizeSortField, text: "Size", currentSortKey: sortKey, currentSortDirection: sortDirection, onClick: this.handleSort }),
                            react_1.default.createElement(SortHeader_1.SortHeader, { className: 'is-2 is-resize has-archive', sortKey: constants_2.creationDateSortField, text: "Received", currentSortKey: sortKey, currentSortDirection: sortDirection, onClick: this.handleSort }),
                            react_1.default.createElement(SortHeader_1.SortHeader, { className: 'is-2 is-variable', sortKey: constants_2.expirationDateSortField, text: "Expires", currentSortKey: sortKey, currentSortDirection: sortDirection, onClick: this.handleSort }),
                            react_1.default.createElement("div", { className: "column is-0 th" })),
                        this.props.packages.map(function (pkg) {
                            return react_1.default.createElement(NewPackageItem, { key: pkg.id, pkg: pkg, asperaEnabled: _this.props.asperaEnabled, asperaInitializing: _this.props.asperaInitializing, maxDownloadSizeInMB: _this.props.downloadSizeLimitInMB, onCancelDismiss: function () { return _this.handleCancelDismiss(pkg.id); }, onCheckTransferStatus: function () { return _this.handleCheckTransferStatus(pkg.id); }, onConfirmDismiss: function () { return _this.handleConfirmDismiss(pkg.id); }, onDismiss: function () { return _this.handleDismiss(pkg.title, pkg.creationDate); }, onDownload: function () { return _this.handleDownload(pkg); }, onDownloadRetry: function () { return _this.handleDownloadRetry(pkg); }, onDownloadStop: function () { return _this.handleDownloadStop(pkg); }, onOpenDownload: function () { return _this.handleOpenDownload(pkg); }, onOpenPreferences: function () { return _this.handleOpenPreferences(); }, onOpenTransferManager: _this.handleOpenTransferManager, onPush: function () { return _this.handleOnPush(pkg.id); }, onRemove: function () { return _this.props.onRemovePackage(pkg.id); }, workgroupPackage: workgroupEmail !== '' });
                        }),
                        this.props.packages.length === 0 &&
                            react_1.default.createElement("div", { className: "columns header is-mobile" },
                                react_1.default.createElement("div", { className: "column is-12 td" },
                                    "No packages found while searching for \"",
                                    this.props.searchTerm,
                                    "\""))),
                ((searchTerm === '' && workgroupEmail === '' && packages.length < totalCount) ||
                    (searchTerm === '' && workgroupEmail !== '' && packages.length < totalSearchCount) ||
                    (searchTerm !== '' && packages.length < totalSearchCount)) &&
                    react_1.default.createElement("div", { className: "has-text-centered" },
                        react_1.default.createElement(Button_1.Button, { type: "button", className: "is-primary", onClick: this.handleLoadMore }, "Load more"))),
            isSearching &&
                react_1.default.createElement(LoadingIndicator_1.LoadingIndicator, { title: loadingPackageTitle })));
    };
    return NewPackages;
}(react_1.Component));
exports.NewPackages = NewPackages;
var NewPackageItem = function (props) {
    var asperaEnabled = props.asperaEnabled, maxDownloadSizeInMB = props.maxDownloadSizeInMB, onCheckTransferStatus = props.onCheckTransferStatus, onDownload = props.onDownload, onDownloadRetry = props.onDownloadRetry, onDownloadStop = props.onDownloadStop, onOpenDownload = props.onOpenDownload, onOpenTransferManager = props.onOpenTransferManager, onPush = props.onPush, onRemove = props.onRemove, pkg = props.pkg, workgroupPackage = props.workgroupPackage;
    var pkgExpirationDiff = moment_1.default(pkg.expirationDate).diff(moment_1.default.now(), 'seconds');
    var pkgExpired = pkg.pkgState === models_1.PackageState.DELETED || pkgExpirationDiff < 0;
    var pkgHeld = pkg.pkgState === models_1.PackageState.HELD;
    /* Defined Elements - begin */
    var checkTransferStatusButton = react_1.default.createElement(RefreshButton_1.RefreshButton, { className: (pkgHeld) ? 'use-blast-yellow' : '', disabled: (!pkgHeld || !!pkg.isUpdating), icon: 'fa-redo', message: (pkg.transferStatus) ? 'Refresh Status' : 'Check Status', showTooltip: false, onRefresh: onCheckTransferStatus });
    var downloadAllButton = react_1.default.createElement(DownloadButton_1.DownloadButton, { disabled: props.asperaInitializing, maxDownloadSizeInMB: asperaEnabled ? undefined : maxDownloadSizeInMB, onDownload: pkg.packageTransferId ? onDownloadRetry : onDownload, pkg: pkg, pkgExpired: pkgExpired });
    var downloadOpenButton = react_1.default.createElement(OpenDownloadButton_1.OpenDownloadButton, { asperaEnabled: asperaEnabled, maxDownloadSizeInMB: asperaEnabled ? undefined : maxDownloadSizeInMB, onDownload: onDownload, onOpenDownload: onOpenDownload, pkg: pkg, pkgExpired: pkgExpired, showDownloadBtn: false });
    var downloadPauseButton = react_1.default.createElement(PauseButton_1.PauseButton, { disabled: props.asperaInitializing, onDownloadStop: onDownloadStop, showTooltip: false });
    var downloadResumeButton = react_1.default.createElement(RetryButton_1.RetryButton, { disabled: props.asperaInitializing, icon: 'fa-play', onDownload: pkg.packageTransferId ? onDownloadRetry : onDownload, showTooltip: false });
    var progressBar = react_1.default.createElement(PackageProgressDetails_1.PackageProgressDetails, { transferredBytes: pkg.transferredBytes, totalBytes: pkg.totalBytes });
    var errorMessage = (pkg.errorMsg ?
        ((pkg.errorDesc) ? pkg.errorMsg + " - " + pkg.errorDesc : pkg.errorMsg) :
        '');
    var packageProgressBar = (pkgHeld && pkg.transferStatus) ?
        react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: classnames_1.default('download-error', 'help', { 'is-danger': pkg.errorMsg }) }, pkg.transferStatus.status === 'stopped' &&
                react_1.default.createElement(react_1.default.Fragment, null, "This transfer has been stopped.")),
            react_1.default.createElement(PackageProgressBar_1.PackageProgressBar, { state: (pkg.transferStatus.status === 'stopped') ? models_1.PackageTransferState.STOPPED : undefined, transferredBytes: Number(pkg.transferStatus.percentage), totalBytes: 100 }))
        : (pkg.state) ?
            react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: classnames_1.default('download-error', 'help', { 'is-danger': pkg.errorMsg }) },
                    pkg.state === models_1.PackageTransferState.FAILED && pkg.errorMsg &&
                        react_1.default.createElement(react_1.default.Fragment, null,
                            errorMessage,
                            ".",
                            react_1.default.createElement(InfoIcon_1.InfoIcon, { tooltipMsg: InfoIcon_1.ASPERA_ACTIVITY_WINDOW_MSG, onClick: function (e) { e.stopPropagation(); onOpenTransferManager(); } })),
                    pkg.state === models_1.PackageTransferState.STOPPED &&
                        react_1.default.createElement(react_1.default.Fragment, null,
                            "This transfer has been stopped.",
                            react_1.default.createElement(InfoIcon_1.InfoIcon, { tooltipMsg: InfoIcon_1.ASPERA_ACTIVITY_WINDOW_MSG, onClick: function (e) { e.stopPropagation(); onOpenTransferManager(); } })),
                    pkg.state === models_1.PackageTransferState.WILLRETRY &&
                        react_1.default.createElement(react_1.default.Fragment, null,
                            "This transfer has failed and will retry approx. 30 seconds.",
                            react_1.default.createElement(InfoIcon_1.InfoIcon, { tooltipMsg: InfoIcon_1.ASPERA_ACTIVITY_WINDOW_MSG, onClick: function (e) { e.stopPropagation(); onOpenTransferManager(); } })),
                    pkg.state === models_1.PackageTransferState.QUEUED &&
                        react_1.default.createElement(react_1.default.Fragment, null,
                            "This transfer has been added to the queue.",
                            react_1.default.createElement(InfoIcon_1.InfoIcon, { tooltipMsg: InfoIcon_1.ASPERA_ACTIVITY_WINDOW_MSG, onClick: function (e) { e.stopPropagation(); onOpenTransferManager(); } }))),
                react_1.default.createElement(PackageProgressBar_1.PackageProgressBar, { state: pkg.state, transferredBytes: pkg.transferredBytes, totalBytes: pkg.totalBytes }))
            : null;
    var transferStatus = (pkg.transferStatus) ?
        (pkg.transferStatus.status.toLowerCase() !== constants_1.TRANSFER_STATUS_NOT_STARTED.toLowerCase()) ?
            react_1.default.createElement(PackageProgressDetails_1.PackageProgressDetails, { percent: Number(pkg.transferStatus.percentage), start_time: (pkg.transferStatus.status === 'transferring') ? pkg.transferStatus.start_time : undefined, stop_time: pkg.transferStatus.stop_time ? pkg.transferStatus.stop_time : moment_1.default(moment_1.default.now()).utc().format(), totalBytes: pkg.totalBytes, transferredBytes: pkg.transferStatus.bytes_transferred })
            : react_1.default.createElement("p", null, "In Queue")
        : null;
    /* Defined Elements - end */
    if (pkg.archived && !workgroupPackage) {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_device_detect_1.isMobile &&
                react_1.default.createElement("hr", null),
            react_1.default.createElement("div", { className: "columns is-mobile", onClick: onPush },
                react_1.default.createElement("div", { className: "column is-1 td is-variable" },
                    react_1.default.createElement("div", { className: "has-text-centered" }, downloadOpenButton)),
                react_1.default.createElement("div", { className: "column is-2 td is-resize has-archive has-text-weight-bold" },
                    pkg.sender.firstName,
                    " ",
                    pkg.sender.lastName),
                react_1.default.createElement("div", { className: "column is-3 td is-resize has-archive subject-title" },
                    pkg.encrypted &&
                        react_1.default.createElement("span", { className: "icon" },
                            react_1.default.createElement("i", { className: "fas fa-lock", title: "Password Protected" })),
                    pkg.title),
                react_1.default.createElement("div", { className: "column is-5 td is-resize has-archive" },
                    react_1.default.createElement("p", { className: "is-size-5 has-text-centered" },
                        "Moved to ",
                        react_1.default.createElement(HistoryLink, null))),
                react_1.default.createElement("div", { className: "column td is-0" },
                    react_1.default.createElement("a", { onClick: function (e) { e.stopPropagation(); onRemove(); } },
                        react_1.default.createElement("span", { className: "icon" },
                            react_1.default.createElement("i", { className: "fas fa-times-circle", title: "Dismiss" })))))));
    }
    if (pkg.dismissBannerVisible && !workgroupPackage) {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_device_detect_1.isMobile &&
                react_1.default.createElement("hr", null),
            react_1.default.createElement("div", { className: "columns is-mobile" },
                react_1.default.createElement("div", { className: "column is-9" },
                    react_1.default.createElement("p", { className: "is-size-5 has-text-centered" },
                        "Move to ",
                        react_1.default.createElement(HistoryLink, null),
                        "?")),
                react_1.default.createElement("div", { className: "column is-2" },
                    react_1.default.createElement("div", { className: "buttons" },
                        react_1.default.createElement(Button_1.Button, { type: "button", className: "button-yellow", onClick: function () { return props.onConfirmDismiss(); } }, "Yes"),
                        react_1.default.createElement(Button_1.Button, { type: "button", onClick: function () { return props.onCancelDismiss(); } }, "No"))))));
    }
    var downloadButton;
    if (pkgHeld) {
        downloadButton = react_1.default.createElement(react_1.default.Fragment, null,
            checkTransferStatusButton,
            transferStatus);
    }
    else {
        if (asperaEnabled) {
            if ((pkg.state === models_1.PackageTransferState.FAILED || pkg.state === models_1.PackageTransferState.STOPPED)) {
                downloadButton =
                    react_1.default.createElement(react_1.default.Fragment, null,
                        downloadResumeButton,
                        progressBar);
            }
            else if (pkg.state === models_1.PackageTransferState.IN_PROGRESS) {
                downloadButton =
                    react_1.default.createElement(react_1.default.Fragment, null,
                        downloadPauseButton,
                        progressBar);
            }
            else {
                var isPackageTransferComplete = pkg.state === models_1.PackageTransferState.COMPLETE;
                var isPackageTransferCompleteRemoved = pkg.state === models_1.PackageTransferState.REMOVED && pkg.totalBytes === pkg.transferredBytes;
                if (isPackageTransferComplete || isPackageTransferCompleteRemoved) {
                    downloadButton = downloadOpenButton;
                }
                else {
                    downloadButton = downloadAllButton;
                }
            }
        }
        else {
            if (pkg.state !== models_1.PackageTransferState.IN_PROGRESS) {
                downloadButton = downloadAllButton;
            }
            else {
                downloadButton = progressBar;
            }
        }
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_device_detect_1.isMobile &&
            react_1.default.createElement("hr", null),
        react_1.default.createElement("div", { className: "columns is-mobile", onClick: onPush },
            react_1.default.createElement("div", { className: "column is-1 td is-variable", onClick: utils_1.unclickable },
                react_1.default.createElement("div", { className: classnames_1.default('has-text-centered', { 'has-text-weight-bold': pkgHeld }, { 'use-blast-yellow': pkgHeld }) }, downloadButton)),
            react_1.default.createElement("div", { className: classnames_1.default('column', 'is-2', 'td', 'is-resize', 'has-archive', 'has-text-weight-bold', { 'use-blast-yellow': pkgHeld }) },
                pkg.sender.firstName,
                " ",
                pkg.sender.lastName),
            react_1.default.createElement("div", { className: classnames_1.default('column', 'is-3', 'td is-resize', 'has-archive', 'subject-title', { 'has-text-weight-bold': pkgHeld }, { 'use-blast-yellow': pkgHeld }) },
                pkg.encrypted &&
                    react_1.default.createElement("span", { className: "icon" },
                        react_1.default.createElement("i", { className: "fas fa-lock", title: "Password Protected" })),
                pkg.title),
            react_1.default.createElement("div", { className: classnames_1.default('column', 'is-1', 'td', 'is-variable', { 'has-text-weight-bold': pkgHeld }, { 'use-blast-yellow': pkgHeld }) },
                react_1.default.createElement(PackageFileSize_1.PackageFileSize, { size: pkg.totalBytes })),
            react_1.default.createElement("div", { className: classnames_1.default('column', 'is-2', 'td', 'is-resize', 'has-archive', { 'has-text-weight-bold': pkgHeld }, { 'use-blast-yellow': pkgHeld }) },
                react_1.default.createElement("span", { className: "tooltip received-date", "data-tooltip": moment_1.default(pkg.creationDate).format(constants_1.DATE_TIME_FORMAT) }, moment_1.default(pkg.creationDate).format(constants_1.DATE_FORMAT))),
            react_1.default.createElement("div", { className: classnames_1.default('column', 'is-2', 'td', 'is-variable', { 'has-text-weight-bold': pkgHeld }, { 'use-blast-yellow': pkgHeld }) },
                react_1.default.createElement(PackageExpiration_1.PackageExpiration, { expirationDate: (pkgHeld) ? '' : pkg.expirationDate, message: (pkg.transferStatus) ? "Upload " + pkg.transferStatus.status : 'Upload Pending' })),
            react_1.default.createElement("div", { className: "column td is-0" }, !workgroupPackage &&
                react_1.default.createElement("a", { onClick: function (e) { e.stopPropagation(); props.onDismiss(); } },
                    react_1.default.createElement("span", { className: "icon" },
                        react_1.default.createElement("i", { className: "fas fa-times-circle", title: "Dismiss" })))),
            react_1.default.createElement("div", { className: "column is-12 td" }, packageProgressBar))));
};
var mapStateToProps = function (store) {
    return {
        activeTransfersList: store.transfers.activeTransfers,
        asperaEnabled: selectors_1.isAsperaEnabled(store),
        asperaInitializing: selectors_1.isAsperaInitializing(store),
        containsArchivedPackages: store.newPackages.containsArchivedPackages,
        httpGatewayStatus: store.transfers.httpGatewayStatus,
        isSearching: store.newPackages.isSearching,
        numPackageRefreshes: (store.dash.numPackageRefreshes !== undefined) ? store.dash.numPackageRefreshes : -1,
        packages: store.newPackages.packages,
        packageCacheLastRefresh: store.dash.packageCacheLastRefresh,
        sortDirection: store.newPackages.sortDirection,
        sortKey: store.newPackages.sortKey,
        totalCount: store.newPackages.totalCount,
        totalSearchCount: store.newPackages.totalSearchCount
    };
};
var mapDispatchToProps = {
    onCancelDismiss: actions_1.cancelDismissNewPackage,
    onCheckTransferStatus: actions_1.checkNewPackageTransferStatus,
    onConfirmDismiss: actions_1.confirmDismissNewPackage,
    onConnectDownload: actions_3.connectDownload,
    onDismiss: actions_1.dismissNewPackage,
    onGetPackages: actions_1.getNewPackages,
    onGetWorkgroupPackages: actions_1.getWorkgroupPackages,
    onHttpDownload: actions_3.httpDownload,
    onHttpGatewayDownload: actions_3.httpGatewayDownload,
    onOpenDownload: actions_3.showDirectory,
    onOpenPreferences: actions_3.showPreferences,
    onOpenTransferManager: actions_3.showTransferManager,
    onPush: actions_2.onPushToPkgDetails,
    onRemovePackage: actions_1.removeReadPackage,
    onResetNewPackages: actions_1.resetNewPackages,
    onResumeConnectTransfer: actions_3.resumeConnectTransfer,
    onRetryHttpUpload: actions_3.retryHttpUpload,
    onSort: actions_1.sort,
    onStopConnectTransfer: actions_3.stopConnectTransfer,
    saveSearchTerm: actions_2.saveSearchTerm
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(NewPackages);
